import { track } from '@amplitude/analytics-browser'
import { useTrackEffect } from '../utils'

const trackCatalogShortAnketaShow = () => track('short_anketa_show').promise

export const useTrackCatalogShortAnketaShow = () =>
  useTrackEffect(trackCatalogShortAnketaShow, {})
